<template>
  <aForm @submit.prevent="onSubmitForm" :form="form">
    <aRow>
      <aCol :span="24">
        <aFormItem class="payments-options">
          <aCheckboxGroup
            v-decorator="[
              `payment_methods${keySuffix}`,
              {
                rules: [
                  {
                    required: false,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
            @change="onPaymentChange"
          >
            <aCheckbox
              v-for="(method, index) in paymentMethodsOptions"
              :key="index"
              :value="method.value"
              :disabled="method.show"
            >
              {{ method.label }}
            </aCheckbox>
          </aCheckboxGroup>
        </aFormItem>
      </aCol>
    </aRow>

    <aRow class="status-bar mb-20">
      <aCol :span="24">
        <strong>VALOR TOTAL</strong>
        <aTag
          class="ml-10"
          :color="totalFees() !== totalToReceive() ? 'red' : 'green'"
        >
          R$ {{ totalFees() | formatPrice }}
        </aTag>

        <span class="equality">
          <span v-if="totalFees() === totalToReceive()">
            <aIcon type="swap" />
          </span>
          <span v-if="totalFees() !== totalToReceive()">
            <aIcon type="swap-right" />
          </span>
        </span>

        <aTag class="ml-10" color="blue">
          R$ {{ totalToReceive() | formatPrice }}
        </aTag>
      </aCol>
    </aRow>

    <aAlert
      class="mb-20 mt-10 f11"
      type="error"
      v-if="totalFees() !== totalToReceive()"
      message="Os valores somados não se equivalem ao total. Verique os valores preenchidos."
      banner
    />

    <div
      v-if="paymentMethods.length"
      class="portal-tabs horizontal payment-tabs"
    >
      <ContractPaymentMethodsValuesPanelModal
        ref="ContractPaymentMethodsValuesPanel"
        :activeTab="activeTab"
        :tempContract="tempContract"
        :paymentMethods="paymentMethods"
        :keyPrefix="keyPrefix"
        :keySuffix="keySuffix"
        @portalActiveTab="portalActiveTab"
      />

      <div class="tabs-content">
        <component
          v-for="(tab, i) in filteredTabsConfig"
          v-bind="tab.props"
          :key="i"
          :form="form"
          :is="tab.component"
          :tempContract="tempContract"
          :reservation_total_price="totalFees()"
          :keyPrefix="keyPrefix"
          :keySuffix="keySuffix"
          @updateTotalValue="updateTotalValue"
        />
      </div>
    </div>

    <div class="a-right" style="clear: both">
      <aDivider />
      <aButton
        class="page-button mb-30"
        type="primary"
        html-type="submit"
        icon="save"
        :loading="loadingSubmit"
        :disabled="loadingSubmit"
      >
        {{ loadingSubmit ? "Salvando, aguarde..." : "Confirmar" }}
      </aButton>
    </div>
  </aForm>
</template>

<script>
import { parse } from "vue-currency-input";

import formatThings from "@/mixins/general/formatThings.js";
import contractPaymentMethodsMixins from "@/components/contracts/mixins/contractPaymentMethodsMixins";

import ThirdPartyTabModal from "../tabs/ThirdPartyTabModal.vue";
import PaymentLinkTabModal from "../tabs/PaymentLinkTabModal.vue";
import CreditCardTabModal from "../tabs/CreditCardTabModal.vue";
import PaymentCardTabModal from "../tabs/PaymentCardTabModal.vue";
import BillingTicketTabModal from "../tabs/BillingTicketTabModal.vue";
import CustomPaymentTabModal from "../tabs/CustomPaymentTabModal.vue";
import BankTransferTabModal from "../tabs/BankTransferTabModal.vue";
import ContractPaymentMethodsValuesPanelModal from "../sections/ContractPaymentMethodsValuesPanelModal.vue";

export default {
  name: "ContractPaymentsReceivable",
  props: {
    tempContract: Object,
    contract: Object,
    keyPrefix: String,
    keySuffix: String,
    baseId: String,
    baseFinancesId: String,
    productsToCancel: Array,
    salesAdditiveType: String,
  },
  components: {
    ThirdPartyTabModal,
    CreditCardTabModal,
    PaymentCardTabModal,
    BankTransferTabModal,
    PaymentLinkTabModal,
    BillingTicketTabModal,
    CustomPaymentTabModal,
    ContractPaymentMethodsValuesPanelModal,
  },
  mixins: [formatThings, contractPaymentMethodsMixins],
  data() {
    return {
      form: this.$form.createForm(this, {
        onValuesChange: this.updateTempContract,
      }),
      paymentMethods: [],
      paymentLinkTotal: "0",
      activeTab: "",
      third_party_payment_rows: [],
      loadingSubmit: false,
      tabsConfig: [
        {
          name: "billing-ticket",
          component: BillingTicketTabModal,
        },
        { name: "credit-card", component: CreditCardTabModal },
        {
          name: "payment-card",
          component: PaymentCardTabModal,
        },
        {
          name: "payment-link",
          component: PaymentLinkTabModal,
        },
        {
          name: "custom-payment",
          component: CustomPaymentTabModal,
        },
        {
          name: "bank-transfer",
          component: BankTransferTabModal,
        },
        {
          name: "third-party",
          component: ThirdPartyTabModal,
          props: {},
        },
      ],
    };
  },
  computed: {
    filteredTabsConfig() {
      return this.tabsConfig.filter((tab) => tab.name === this.activeTab);
    },
  },
  mounted() {
    this.paymentMethods = this.tempContract[`payment_methods${this.keySuffix}`]
      ? JSON.parse(this.tempContract[`payment_methods${this.keySuffix}`])
      : [];

    this.form.setFieldsValue({
      [`payment_methods${this.keySuffix}`]: this.paymentMethods,
    });

    this.activeTab = this.paymentMethods.length
      ? this.paymentMethods[0]
      : "none";
  },
  methods: {
    updateTempContract(props, fields) {
      let field = Object.keys(fields)[0],
        value = Object.values(fields)[0];

      this.tempContract[field] = value;

      if (Array.isArray(value)) {
        this.tempContract[field] = JSON.stringify(value);
      }

      this.tempContract = { ...this.tempContract };

      this.$emit("onChangeCancelProductData", this.tempContract);
    },
    portalActiveTab(active) {
      this.activeTab = active;
    },
    updateTotalValue() {
      this.totalToReceive();
      this.$refs.ContractPaymentMethodsValuesPanel.$emit("updateTotalValue");
    },
    totalToReceive() {
      let total = 0;

      const receivedTotal = this.paymentMethods.reduce((acc, method) => {
        if (method === "billing-ticket") {
          return (
            acc +
            parse(
              this.tempContract[
                `payment_methods_billing_ticket_total_value${this.keySuffix}`
              ]
            )
          );
        } else if (method === "payment-card") {
          return (
            acc +
            parse(
              this.tempContract[
                `payment_methods_payment_card_total_value${this.keySuffix}`
              ]
            )
          );
        } else if (method === "credit-card") {
          return (
            acc +
            parse(
              this.tempContract[
                `payment_methods_credit_card_total_value${this.keySuffix}`
              ]
            )
          );
        } else if (method === "custom-payment") {
          return (
            acc +
            parse(
              this.tempContract[
                `payment_methods_custom_payment_total_value${this.keySuffix}`
              ]
            )
          );
        } else if (method === "bank-transfer") {
          return (
            acc +
            parse(
              this.tempContract[
                `payment_methods_bank_transfer_total_value${this.keySuffix}`
              ]
            )
          );
        } else if (method === "payment-link") {
          return (
            acc +
            parse(
              this.tempContract[
                `payment_methods_payment_link_total_value${this.keySuffix}`
              ]
            )
          );
        }
        return acc;
      }, total);

      this.tempContract[`contract_cancellation_mode_total_to_receive_value`] =
        receivedTotal;

      return receivedTotal;
    },

    totalFees() {
      let total = 0;

      const contractedServices = this.tempContract[`contracted_services`]
        ? JSON.parse(this.tempContract[`contracted_services`])
        : [];

      const hotelRows = this.tempContract[`hotel_rows`]
        ? JSON.parse(this.tempContract[`hotel_rows`])
        : [];

      const serviceRows = this.tempContract[`service_rows`]
        ? JSON.parse(this.tempContract[`service_rows`])
        : [];

      const flightSectionsRows = this.tempContract[`flight_sections_rows`]
        ? JSON.parse(this.tempContract[`flight_sections_rows`])
        : [];

      const verifyValues = [1, "1", true];
      const feeTypes = ["change_tax", "fine_fee", "supplier_fine_fee"];

      // Calculate hotel fees
      if (contractedServices.includes("hotel")) {
        hotelRows.forEach((item) => {
          if (this.salesAdditiveType === "Cancelar Venda") {
            feeTypes.forEach((feeType) => {
              const isActive =
                this.tempContract[
                  `contract_finances_hotel_${item.id}_${feeType}_active`
                ];
              if (verifyValues.includes(isActive)) {
                total += parse(
                  this.tempContract[
                    `contract_finances_hotel_${item.id}_${feeType}_value`
                  ]
                );
              }
            });
          } else {
            if (this.productsToCancel.includes(`hotel-${item.id}`)) {
              feeTypes.forEach((feeType) => {
                const isActive =
                  this.tempContract[
                    `contract_finances_hotel_${item.id}_${feeType}_active`
                  ];
                if (verifyValues.includes(isActive)) {
                  total += parse(
                    this.tempContract[
                      `contract_finances_hotel_${item.id}_${feeType}_value`
                    ]
                  );
                }
              });
            }
          }
        });
      }

      // Calculate service fees
      if (contractedServices.includes("service")) {
        serviceRows.forEach((item) => {
          if (this.salesAdditiveType === "Cancelar Venda") {
            feeTypes.forEach((feeType) => {
              const isActive =
                this.tempContract[
                  `contract_finances_service_${item.id}_${feeType}_active`
                ];
              if (verifyValues.includes(isActive)) {
                total += parse(
                  this.tempContract[
                    `contract_finances_service_${item.id}_${feeType}_value`
                  ]
                );
              }
            });
          } else {
            if (this.productsToCancel.includes(`service-${item.id}`)) {
              feeTypes.forEach((feeType) => {
                const isActive =
                  this.tempContract[
                    `contract_finances_service_${item.id}_${feeType}_active`
                  ];
                if (verifyValues.includes(isActive)) {
                  total += parse(
                    this.tempContract[
                      `contract_finances_service_${item.id}_${feeType}_value`
                    ]
                  );
                }
              });
            }
          }
        });
      }

      // Calculate flight fees
      if (contractedServices.includes("flight")) {
        flightSectionsRows.forEach((item) => {
          if (this.salesAdditiveType === "Cancelar Venda") {
            feeTypes.forEach((feeType) => {
              const isActive =
                this.tempContract[
                  `contract_finances_flight_${item.id}_${feeType}_active`
                ];
              if (verifyValues.includes(isActive)) {
                total += parse(
                  this.tempContract[
                    `contract_finances_flight_${item.id}_${feeType}_value`
                  ]
                );
              }
            });
          } else {
            if (this.productsToCancel.includes(`flight-${item.id}`)) {
              feeTypes.forEach((feeType) => {
                const isActive =
                  this.tempContract[
                    `contract_finances_flight_${item.id}_${feeType}_active`
                  ];
                if (verifyValues.includes(isActive)) {
                  total += parse(
                    this.tempContract[
                      `contract_finances_flight_${item.id}_${feeType}_value`
                    ]
                  );
                }
              });
            }
          }
        });
      }

      this.tempContract[`contract_cancellation_mode_total_fees_value`] = total;

      return total;
    },
    onPaymentChange(payments) {
      this.paymentMethods = payments;
      this.activeTab = payments.length ? payments[0] : "";
    },
    protectData(data) {
      return data ? "x".repeat(data.length) : "";
    },
    filterOnlyPaymentMethods() {
      this.protectCreditCardData();

      const activeTab = this.activeTab.replace(/-/g, "_"); //
      const paymentKeys = Object.keys(this.tempContract).filter(
        (key) =>
          (key.startsWith(`payment_methods_${activeTab}`) &&
            key.endsWith("_new")) ||
          key === `payment_methods_new` ||
          (key.startsWith(`${activeTab}`) && key.endsWith("_new")) ||
          (!key.startsWith("contract_finances_") && key.endsWith("_rows_new"))
      );

      const result = {};
      paymentKeys.forEach((key) => {
        result[key] = this.tempContract[key];
      });

      return result;
    },
    protectCreditCardData() {
      if (!this.tempContract[`credit_card_rows${this.keySuffix}`]) return;

      const fields = ["name", "number", "month", "year", "cvv", "flag"];

      JSON.parse(
        this.tempContract[`credit_card_rows${this.keySuffix}`]
      ).forEach((card) => {
        fields.forEach((field) => {
          const clientField = `payment_methods_credit_card_client_${field}_${card.id}${this.keySuffix}`;
          const maskedField = `payment_methods_credit_card_masked_${field}_${card.id}${this.keySuffix}`;

          if (this.tempContract[clientField]) {
            this.tempContract[maskedField] = this.protectData(
              this.tempContract[clientField]
            );
          }
        });
      });
    },
    onSubmitForm(e) {
      e.preventDefault();
      this.form.validateFields((err) => {
        if (!err) {
          this.loadingSubmit = true;
          this.$emit("onIsSavingData", this.loadingSubmit);
          const theValues = this.filterOnlyPaymentMethods();

          this.$http
            .post("/contract/update-multi-meta", {
              id: this.tempContract.id,
              ...theValues,
              [`contract_cancellation_mode_total_fees_value`]:
                this.tempContract[
                  `contract_cancellation_mode_total_fees_value`
                ] ?? 0,
              [`contract_cancellation_mode_total_to_receive_value`]:
                this.tempContract[
                  `contract_cancellation_mode_total_to_receive_value`
                ] ?? 0,

              modified_by: {
                name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
                id: this.$store.state.userData.id,
              },
            })
            .then(({ data }) => {
              this.$message.success(data.message);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.$emit("onIsSavingData", this.loadingSubmit);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-button {
  background: #00acec;
  border-color: #00acec;
}

.page-button:hover {
  background: #00a4e0;
  border-color: #00a4e0;
}

.payments-options {
  color: #ffffff;
  padding: 10px 20px 5px;
  border: 1px solid #ddd !important;
  margin: 0 0 10px;
  border-radius: 6px;
  label {
    font-size: 13px;
    margin: 0;
    padding: 5px 0;
    width: 25%;
    font-weight: 500;
  }
}

.equality {
  font-size: 19px;
  margin-bottom: 0;
  position: relative;
  top: 4px;
  font-weight: 500;
  color: rgb(76, 56, 141);
}
</style>
